import { httpClient, reportAxios } from "ultis/axios";

/**api danh sách nghiệp vụ */
const getListBusiness = (params) => {
  return httpClient.get("/cloud-pbx/business", { params });
};

/**api xuất danh sách nghiệp vụ */
const exportListBusiness = (params) => {
  return reportAxios.get("/api/v1/reports/export-business", {
    params,
  });
};

/**api danh sách đầu số nghiệp vụ */
const getListBusinessPhoneNumber = (params) => {
  return httpClient.get("/cloud-pbx/phonenumberdefaults", { params });
};

/**api xuất danh sách đầu số nghiệp vụ */
const exportListBusinessPhoneNumber = (params) => {
  return reportAxios.get("/api/v1/reports/export-phonenumberdefault", {
    params,
  });
};

/**api danh sách người dùng nghiệp vụ */
const getListBusinessUser = (params) => {
  return reportAxios.get("/api/v1/users/license", { params });
};

/**api danh sách máy lẻ nghiệp vụ */
const getListBusinessExtension = (params) => {
  return reportAxios.get("/api/v1/extensions/license", { params });
};

/**api lấy danh sách báo cáo tổng hợp*/
const getListBusinessReport = (params) => {
  return reportAxios.get("/api/v1/report-general", {
    params,
  });
};

/**api lấy danh sách loại báo cáo*/
const getListBusinessReportType = (params) => {
  return reportAxios.get("/api/v1/report-schedule/type", {
    params,
  });
};

/**api lấy danh sách loại tổng đài*/
const getListBusinessPbxType = (params) => {
  return httpClient.get("/cloud-pbx/switchboards", {
    params,
  });
};

export const BusinessManagementApi = {
  getListBusiness,
  exportListBusiness,
  getListBusinessPhoneNumber,
  exportListBusinessPhoneNumber,
  getListBusinessUser,
  getListBusinessExtension,
  getListBusinessReport,
  getListBusinessReportType,
  getListBusinessPbxType,
};
